module.exports = __webpack_public_path__ + "static/media/logo-outline.2f36dac4.png";